var map = {
	"./customBold/index.ts": "13a8",
	"./customH1/index.ts": "ceb3",
	"./customH2/index.ts": "df22",
	"./customH3/index.ts": "fd5f",
	"./customH4/index.ts": "c8fb",
	"./customImage/index.ts": "8e60",
	"./customItalic/index.ts": "f207",
	"./customJustifyCenter/index.ts": "28fe",
	"./customJustifyLeft/index.ts": "f3f3",
	"./customJustifyRight/index.ts": "8dcf",
	"./customSplitLine/index.ts": "0555",
	"./customStrikeThrough/index.ts": "2e9c",
	"./customUnderline/index.ts": "06f9",
	"./customVideo/index.ts": "1aec",
	"./index.ts": "1198",
	"./insertAnswer/index.ts": "2207",
	"./insertGame/index.ts": "62d2",
	"./insertTiezi/index.ts": "0060",
	"./insertVideo/index.ts": "81f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b8c";